import { useEffect, useState } from "react";
import './customiseprojectSlider.css'; 

const slider1 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/1.jpeg";
const slider2 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/2.jpg";
const slider3 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/3.jpeg";
const slider4 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/4.jpg";
const slider5 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/5.jpeg";
const slider6 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/6.jpg";
const slider7 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/7.jpeg";
const slider8 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/8.jpg";
const slider9 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/9.jpeg";
const slider10 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/10.jpg";
const slider11 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/11.jpeg";
const slider12 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/12.jpg";
const slider13 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/13.jpeg";
const slider14 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/14.jpg";
const slider15 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/15.jpeg";
const slider16 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/16.jpg";
const slider17 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/17.jpeg";
const slider18 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/18.jpg";
const slider19 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/19.jpeg";
const slider20 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/20.jpg";
const slider21 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/21.jpeg";
const slider22 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/22.jpg";
const slider23 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/23.jpeg";
const slider24 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/24.jpg";
const slider25 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/25.jpeg";
const slider26 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/26.jpg";
const slider27 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/27.jpg";
const slider28 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/28.jpg";
const slider29 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/29.jpg";
const slider30 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/30.jpg";
const slider31 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/31.jpg";
const slider32 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/32.jpg";
const slider33 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/33.jpg";
const slider34 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/34.jpg";
const slider35 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/35.jpg";
const slider36 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/36.jpg";
const slider37 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/37.jpg";
const slider38 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/38.jpg";
const slider39 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/39.jpg";
const slider40 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesCustomiseprojectSlider/40.jpg";


const CustomiseprojectSlider = () => {
  const images = [
    slider1, slider2, slider3, slider4, slider5, slider6, slider7, slider8,
    slider9, slider10, slider11, slider12, slider13, slider14, slider15, slider16,
    slider17, slider18, slider19, slider20, slider21, slider22, slider23, slider24,
    slider25, slider26, slider27, slider28, slider29, slider30, slider31, slider32,
    slider33, slider34, slider35, slider36, slider37, slider38, slider39, slider40
  ];

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartAnimation(true);
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  // Define the speed multiplier here. A smaller number means faster.
  const animationSpeedMultiplier = 1.0; // You can adjust this value (e.g., 1.5, 0.5, etc.)
  const imageWidth = 300; // This should match the 'min-w-[300px]' in Tailwind

  return (
    <div className="w-full bg-white py-16">
      <h2 className="text-center text-4xl font-serif text-gray-500 py-6 tracking-wide">
        RECENT PROJECTS
      </h2>

      <div className="w-full h-[400px] overflow-hidden relative flex justify-center items-center bg-white">
        {/* Show first image while waiting */}
        {!startAnimation && (
          <img
            src={images[0]}
            alt="Preview"
            className="h-full object-contain transition-opacity duration-500"
          />
        )}

        {/* Infinite Scrolling */}
        {startAnimation && (
         <div
  className="slider-track flex"
  style={{
    animation: `scrollSlider ${images.length * animationSpeedMultiplier}s linear infinite`,
    width: `${images.length * 2 * imageWidth}px`
  }}
  // Pause when pressing on mobile/tablet
  onTouchStart={(e) => {
    e.currentTarget.style.animationPlayState = "paused";
  }}
  onTouchEnd={(e) => {
    e.currentTarget.style.animationPlayState = "running";
  }}
  // Optional: also pause if mouse button is held down (desktop)
  onMouseDown={(e) => {
    e.currentTarget.style.animationPlayState = "paused";
  }}
  onMouseUp={(e) => {
    e.currentTarget.style.animationPlayState = "running";
  }}
>
  {[...images, ...images].map((image, index) => (
    <div
      key={index}
      className="flex-shrink-0 h-[400px] min-w-[300px] flex justify-center items-center"
    >
      <img
        src={image}
        alt={`Slide ${index}`}
        className="h-full object-contain"
      />
    </div>
  ))}
</div>

        )}
      </div>
    </div>
  );
};

export default CustomiseprojectSlider;